import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicProjectListParamsRawI,
	type LWApiPublicProjectListResultRawI,
} from '@liquidweb-dev/club-sauce/public/project/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { supplementDetails } from './useDetails';

const supplementData = (data: LWApiPublicProjectListResultRawI) => {
	const supplementedItems = data.items.map((project) =>
		supplementDetails(project),
	);

	return { ...data, items: supplementedItems };
};

export const PROJECT_LIST_QUERY_KEY = '/project/list';

const useProjectList = (
	params: LWApiPublicProjectListParamsRawI,
	options?: Omit<
		UseQueryOptions<LWApiPublicProjectListResultRawI, ApiErrorI>,
		'select'
	>,
) =>
	useQuery({
		queryKey: [PROJECT_LIST_QUERY_KEY, params],
		queryFn: () => api.project.apiRaw.list(params),
		select: supplementData,
		...options,
	});

export default useProjectList;
